import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { joinList } from './puzzleApi';
import './CaseFile.css';

const ERROR_MESSAGES = {
  nickname_has_at: "Please don't use an email address as your nickname. It's shown publicly.",
  nickname_invalid: 'Nicknames are 3 to 24 characters: letters, numbers, spaces, dots, dashes or underscores.',
  nickname_blocked: 'Please pick a different nickname.',
  nickname_taken: 'That nickname is taken. Please try another.',
  email_invalid: "That email address doesn't look right.",
  email_registered: 'That email is already on the list.',
  email_unavailable: "That email address can't be added right now. If you unsubscribed before, email me at jerry@jerryevanoff.com.",
  already_member: "You've already joined.",
  rate_limited: 'Too many tries. Please wait a little and try again.',
  default: 'Something went wrong. Please try again.'
};

const CaseJoin = ({ guid }) => {
  const navigate = useNavigate();
  const [nickname, setNickname] = useState('');
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [errorCode, setErrorCode] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (submitting) {
      return;
    }

    setSubmitting(true);
    setErrorCode(null);

    try {
      await joinList(guid, nickname.trim(), email.trim());
      navigate('/thank-you');
    } catch (error) {
      setErrorCode(error.code || 'default');
      setSubmitting(false);
    }
  };

  const canSubmit = nickname.trim() !== '' && email.trim() !== '' && !submitting;

  return (
    <section className="cf-join" aria-labelledby="cf-join-heading">
      <h2 id="cf-join-heading">Want to keep score?</h2>
      <p className="cf-brief">
        Pick a detective nickname and join my mailing list. I'll track the cases you solve, rank you on the
        leaderboard and email you when the next case is released.
      </p>

      <form onSubmit={handleSubmit} noValidate>
        <div className="cf-field">
          <label className="cf-flabel" htmlFor="cf-nickname">Nickname <span className="cf-hint-text">(shown on the leaderboard)</span></label>
          <input
            type="text"
            id="cf-nickname"
            value={nickname}
            maxLength={24}
            autoComplete="nickname"
            disabled={submitting}
            aria-invalid={errorCode !== null && errorCode.startsWith('nickname')}
            onChange={(event) => setNickname(event.target.value)}
          />
        </div>

        <div className="cf-field">
          <label className="cf-flabel" htmlFor="cf-email">Email <span className="cf-hint-text">(never shown to anyone)</span></label>
          <input
            type="email"
            id="cf-email"
            value={email}
            placeholder="you@example.com"
            autoComplete="email"
            disabled={submitting}
            aria-invalid={errorCode !== null && errorCode.startsWith('email')}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <p className="cf-fineprint">
          By joining, you're subscribing to my newsletter. I'll email you about new cases and now and then about my
          books. You can unsubscribe at any time. <Link to="/privacypolicy">Privacy Policy</Link>
        </p>

        <button type="submit" className="cf-cta" disabled={!canSubmit}>
          {submitting ? 'Joining…' : 'Join the list'}
        </button>

        {errorCode !== null && (
          <p className="cf-error" role="alert">
            {ERROR_MESSAGES[errorCode] || ERROR_MESSAGES.default}
          </p>
        )}
      </form>
    </section>
  );
};

export default CaseJoin;
